
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/migration/migration-charts-v8",
      function () {
        return require("private-next-pages/x/migration/migration-charts-v8.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/migration/migration-charts-v8"])
      });
    }
  